import React from 'react';
import PropTypes from 'prop-types';

/*** styles ***/
import './style.css';

export const VerticalArrows = (props) => {

  /*** calculate arrow width relatively screen width if received maxArrowWidth and minArrowWidth from props
   *  or it will be static arrowWidth
   * ***/
  const calculatedArrowWidth = (props.maxArrowWidth && props.minArrowWidth) ?
    `calc( (100vw - 375px)/(1920 - 375) * (${props.maxArrowWidth} - ${props.minArrowWidth}) + ${props.minArrowWidth}px)` :
    `${props.arrowWidth}`,

    /*** calculate arrow height relatively screen width if received maxArrowHeight and minArrowHeight from props
     *  or it will be static arrowHeight
     * ***/
    calculatedArrowHeight = (props.maxArrowHeight && props.minArrowHeight) ?
      `calc( (100vw - 375px)/(1920 - 375) * (${props.maxArrowHeight} - ${props.minArrowHeight}) + ${props.minArrowHeight}px)` :
      `${props.arrowHeight}`,

    /*** this arrows is absolutely positioned, it means that from props can receive margin ***/
    margin = (props.marginLeft || props.marginRight) ?
      {marginLeft: props.marginLeft, marginRight: props.marginRight} :
      {margin: props.margin},

    styleVerticalArrows = {
      width: calculatedArrowWidth,
      gridTemplateRows: `${calculatedArrowHeight} auto ${calculatedArrowHeight}`,
      ...margin
    },
    styleTopArrow = {
      borderLeft: `${calculatedArrowWidth} solid transparent`,
      borderRight: `${calculatedArrowWidth} solid transparent`,
      borderBottom: `${calculatedArrowHeight} solid ${props.borderColor}`
    },
    styleBottomArrow = {
      borderLeft: `${calculatedArrowWidth} solid transparent`,
      borderRight: `${calculatedArrowWidth} solid transparent`,
      borderTop: `${calculatedArrowHeight} solid ${props.borderColor}`
    },
    styleHorizontalLineArrow = {
      border: `1px solid ${props.borderColor}`
    },
    styleInputHorizontalArrow = {
      /*
      bottom: props.bottom,
      top: props.top
      */
      color: `${props.borderColor}`
    };


  return (
    <div className="vertical-arrows" style={styleVerticalArrows}>
      <div className="wrapper-top-arrow">
        <span className="top-arrow" style={styleTopArrow}/>
      </div>
      <div className="wrapper-horizontal-line-arrow">
        <span className="horizontal-line-arrow" style={styleHorizontalLineArrow}/>
        <p className="input-horizontal-line-arrow" style={styleInputHorizontalArrow}>{props.value}</p>
        {/*
          {props.isInput ?
            <input
              style={styleInputHorizontalArrow}
              min={0}
              step={props.step || 20}
              type="number"
              className="input-horizontal-line-arrow"
              data-input-name={props.dataInputName}
              onChange={props.changeInputValue}
              value={props.value}
              disabled={props.value && !props.changeInputValue}
            /> :
            null}
        */}
      </div>
      <div className="wrapper-bottom-arrow">
        <span className="bottom-arrow" data-input-name={props.dataInputName} style={styleBottomArrow}/>
      </div>
    </div>
  );
};

/*** default props for Vertical Arrow ***/
VerticalArrows.defaultProps = {
  arrowHeight: "10px",
  arrowWidth: "5px",
  borderColor: "black",
  margin: "auto"
};

/*** PropTypes Vertical Arrows***/
VerticalArrows.propTypes = {
  arrowHeight: PropTypes.string,
  arrowWidth: PropTypes.string,
  borderColor: PropTypes.string,
  maxArrowWidth: PropTypes.number,
  minArrowWidth: PropTypes.number,
  maxArrowHeight: PropTypes.number,
  minArrowHeight: PropTypes.number,
  marginLeft: PropTypes.string,
  marginRight: PropTypes.string,
  bottom: PropTypes.string,
  top: PropTypes.string,
  isInput: PropTypes.bool,
  dataInputName: PropTypes.string,
  changeInputValue: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};




// WEBPACK FOOTER //
// ./src/components/buildcomponent/VerticalArrows/VerticalArrows.js